import React from "react";
import bgImage from "../assets/Academy/bg.png";
import logo from "../assets/Academy/logo.png"; // Make sure to import your logo image

const Header = () => {
  return (
    <section
      className="relative flex flex-col font-display justify-end items-start p-5 md:pt-36 mt-12 md:mt-10 2xl:mt-16 w-full"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
        aspectRatio: "16/9",
        minHeight: "300px",
        maxHeight: "600px",
      }}
    >

      <div className="absolute top-10  md:top-16 lg:top-20 left-4 md:left-16 z-20">
        <img 
          src={logo} 
          alt="Randomwalk Logo" 
          className="w-32 md:w-44 lg:w-64 2xl:w-72 object-contain"
        />
      </div>

      <article className="relative flex flex-col items-start md:flex-row md:items-end md:justify-between z-10 w-full">
        <div className="md:pb-10 pb-5 md:pl-10 pl-1 md:w-3/4 2xl:w-8/12">
          <p className="text-white text-md md:text-xl lg:text-4xl 2xl:text-4xl font-bold mb-2  md:mb-3 lg:mb-6 mt-0">
            Learn with Randomwalk
          </p>
          <div className="text-white text-xs md:text-base lg:text-2xl 2xl:text-2xl font-medium drop-shadow-md">
            <span>
              At Randomwalk we have a range of options to help upskill, reskill, or introduce your team or business to a range of portfolios and disciplines. If you're looking for 3 hour workshops; or 6 month courses to upskill or reskill your team
            </span>
          </div>
        </div>
      </article>
    </section>
  );
};

export default Header;